import dex from './dex'
import migration from './migration'
import points from './points'
import rebate from './rebate'
export default {
  home: {
    app: 'Memeshot',
    title: "Memeshot.com , that's the meme.",
    subTitle: "Find a meme coin, take a shot, take profit. That's it.",
    inviteFriends: 'Join the pros, catch ',
    inviteTextEnd: ' MEME gains!',
    appStore: 'App Store',
    testFlight: 'TestFlight',
    googlePlay: 'Google Play',
    android: 'Android',
    scanToDownload: 'Scan to download',
    soon: 'Soon',
    downloadFrom: 'Download from',
    appDownload: 'Download Apk',
    joinUs: 'Join Us',
    followUs: 'Follow Us',
    learn: 'Learn',
  },
  referralCenter: {
    inviteFriend: 'Earn a 30% bonus on fees generated by users you refer',
    referralRules: 'Rules',
    totalReward: 'My Total Rewards',
    usdtAmount: '$',
    referralCount: 'Referrals',
    defaultReferral: 'My Commission Rebate',
    youReceive: 'My Rebate Rate',
    receiveAmount: '50%',
    referralLink: 'Referral Link',
    inviteButton: 'Invite Friends Now!',
    referralOverview: 'Referral Center',
    totalReferralIncome: 'Total Rebates',
    totalReferralCount: 'Total Referrals',
    myInvitations: 'My Invitations',
    myRebates: 'My Rebates',
    userId: 'User ID',
    rebateRate: 'Rebate Rate',
    registrationTime: 'Registration Time',
    releaseTime: 'Release Time',
    rebateAmount: 'Rebate Amount',
    status: 'Status',
    pendingRelease: 'Unreleased',
    released: 'Released',
    copied: 'Copied',
    dataDetails: 'Details',
    joinBtn: 'Strategic Partnership',
    title1: 'Invite Regular Community Members (R)',
    desc1: 'R can earn a 10% bonus on fees from referred users.',
    title2: 'Invite Golden Community Leaders (G)',
    desc2: 'G can earn a 50% bonus on fees from referred users.',
    title3: 'Invite Silver Community Leaders (S)',
    desc3: 'S can earn a 40% bonus on fees from referred users.',
    invitation: 'Invite Friends',
    pageTitle: 'Invite Friends',
    pageSubtitle: 'Earn a ** bonus on fees generated by users you refer',
    invitationRelationship: 'Relationship',
    rebateRatio: 'Commission Rate',
    inviterID: 'Inviter ID',
    hash: 'Txid',
    prePage: 'Prev',
    nextPage: 'Next',
  },
  referralRulesTexts: {
    text0: 'Invitation Levels:',
    text1: 'Golden Community Leader (G)',
    text2: 'Silver Community Leader (S)',
    text3: 'Regular Community Member (R)',
    text4: 'Commission Rules:',
    text5: 'Golden Community Leader (G):',
    text6:
      'Earn 40% of transaction fee commissions from directly invited Silver Community Leaders (S).',
    text7:
      'Earn 50% of transaction fee commissions from directly invited Regular Community Members (R).',
    text8:
      'Earn 10% of transaction fee commissions from indirectly invited Regular Community Members (R).',
    text9: 'Silver Community Leader (S):',
    text10:
      'Earn 40% of transaction fee commissions from directly invited Regular Community Members (R).',
    text11: 'Regular Community Member (R):',
    text12:
      'Earn 10% of transaction fee commissions from directly invited Regular Community Members (R).',
    text13: 'How to Obtain a Role:',
    textRoleTitle1: 'Golden Community Leader (G):',
    text14:
      "Reach total commissions of $50,000 or apply for the role through 'Strategic Partnership'",
    textRoleTitle2: 'Silver Community Leader (S):',
    text15:
      "Reach total commissions of $30,000 or apply for the role through 'Strategic Partnership.'",
    textRole2Text:
      'Register through an invitation link shared by a Golden Community Leader (G).',
    textRoleTitle3: 'Regular Community Member (R):',
    text16:
      'Register directly, or Be invited by a Golden Community Leader (G), Silver Community Leader (S), or another Regular Community Member (R).',
    text17: 'Commission：',
    text18: 'Commissions are settled when the total amount reaches $5.',
  },
  register: {
    title: 'Create Memeshot Account',
    account: 'Account',
    email: 'Email',
    accountPlaceholder: 'Enter Email Address',
    accountErrMsg: 'Invalid email address',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    passwordErrMsg:
      'Password must contain at least three of: lowercase, uppercase, numbers, or special characters',
    passwordErrMsgOne: 'Must contain at least 8 characters',
    passwordErrMsgTwo: 'Cannot exceed 20 characters.',
    passwordErrMsgThree: 'Must contain at least one number and one letter.',
    signIn: 'Login',
    signUp: 'Register',
    verifyBtn: 'Get Code',
    verify: 'Code',
    verifyDesc: 'Enter verification code.',
    emailVerify: 'Email Verification Code',
    emailVerifyPlaceholder: 'Enter Verification Code',
    resend: 'Resend',
    confirm: 'Confirm',
    confirmPassword: 'Confirm password',
    confirmPasswordErr: 'The two password inputs are inconsistent',
    inviteCode: 'Invitation Code (Optional)',
    quick_login: 'Quick Log In',
  },
  Cancellation: {
    logoffAccount: 'Apply for account cancellation ',
    reason: 'Reason',
    reasonCancellation: 'Reason for cancellation of account',
    applyInTitle: 'Under review. Thanks for your support',
    applyDoneText: 'Cancellation succeeded',
    cancelApplyButton: 'Cancel Application',
    submit: 'Submit',
    cancelApply: 'Cancel Apply',
  },

  // 目前只支持英文版
  userAgreement: {
    welcome: 'Thank you for using Memeshot!',
    policyMainText:
      'This Privacy Policy details how we collect, use, disclose, and protect your personal information to ensure your privacy rights. We are committed to complying with data privacy laws and regulations and safeguarding the security of your personal information.',
    part1: '1. Protection of Information',
    part1Text:
      'In the course of using this application, we may protect information including but not limited to the following types:',
    part1_1: '1.1 User Identity Information',
    part1_1Text:
      '- Wallet Address: The blockchain wallet address you create or connect to this application. We do not collect your real identity information.',
    part1_1Text2:
      '- Transaction Records: Necessary on-chain transaction records used to provide services, which do not include any unnecessary personal identification information.',
    part1_2: '1.2 Usage Information',
    part1_2Text:
      '- Application Usage Data: We automatically collect your interaction data with this application, such as page visits, clicks, and browsing behavior, to help us optimize application features and user experience.',
    part1_3: '1.3 Device Information',
    part1_3Text:
      "- Device Identifiers and Operating System: Includes the device's operating system version and unique device identifier, used to ensure the normal operation and security of the application.",
    part2: '2. Use of Information',
    part2Text:
      'We strictly use your information in a legal, proper, and necessary manner in accordance with this Privacy Policy and relevant laws and regulations. The specific purposes are as follows:',
    part2_1:
      '- Providing and Maintaining Services: Processing on-chain transactions to ensure the normal operation of the custodial wallet.',
    part2_2:
      '- Improving User Experience: Continuously optimizing product features and user interfaces by analyzing application usage behaviors.',
    part2_3:
      '- Ensuring Security: Detecting, preventing, and resolving fraud and illegal activities to protect the security of your assets.',
    part3: '3. Sharing of Information',
    part3Text:
      'We do not sell, rent, or share your personal information with any third parties, but we may share your information under the following circumstances:',
    part3_1:
      'Third-Party Service Providers: To provide application functionalities, we may need to share necessary information with trusted third-party partners. These third parties are limited to using your information only within the scope required to provide their services.',
    part3_2:
      'Legal Requirements: Your information may need to be disclosed if required by laws, legal processes, or government requests.',
    part4: '4. Security of Information',
    part4Text:
      'We are committed to protecting the security of your personal information and have implemented reasonable technical and managerial measures to prevent unauthorized access, disclosure, alteration, or destruction of your information. However, the network environment is not 100% secure, so please properly safeguard your wallet keys and other sensitive information.',
    part5: '5. Privacy Protection for Minors',
    part5Text:
      'This application is not intended for minors. If we discover that we have collected personal information from minors, we will take steps to delete the relevant data as soon as possible.',
    part6: '6. Your Rights',
    part6Text:
      'Under applicable data protection laws, you have the right to perform the following actions regarding your information:',
    part6_1:
      'Access, Update, and Deletion: You can access, update, or delete your account information.',
    part6_2:
      'Privacy Settings: You can adjust your privacy settings within the application at any time to manage how your information is collected and used.',
    part7: '7. Changes to the Privacy Policy',
    part7Text:
      'We may update this Privacy Policy from time to time. The updated Privacy Policy will be posted on this page with the effective date indicated. We recommend that you regularly review the Privacy Policy to stay informed about our latest privacy protection measures.',
  },
  dex: dex.en_US,
  points: points.en_US,
  rebate: rebate.en_US,
  migration: migration.en_US,
}
